import { useDispatch } from 'react-redux';
import { Button, ErrorFailProcessSVG } from 'common-ui-components';
import PropTypes from 'prop-types';
import { navigateTo } from '../redux/Slice/navigationSlice';

const GenericError = ({ text, icon, targetScreen, mustReload }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (mustReload) {
      window.location.reload();
    } else if (targetScreen) {
      dispatch(navigateTo(targetScreen));
    }
  }

  return (
    <div className='section'>
      <header className='error-screen-header'>
        {icon || <ErrorFailProcessSVG transparent style={{ height: '150px' }} />}
        <h3 className='error-screen-title white-space-text'>{text.title}</h3>
        {text.description && (
          <p className='error-screen-sugest white-space-text'>{text.description}</p>
        )}
      </header>
      <div className='error-screen-action-top'>
        {text.button && (
          <Button
            onClick={handleClick}
            className='submit-button-error'
            data-testid='error-screen-button'
          >
            {text.button}
          </Button>
        )}
      </div>
    </div>
  );
};

GenericError.propTypes = {
  text: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    button: PropTypes.string,
  }).isRequired,
  targetScreen: PropTypes.string,
  icon: PropTypes.element,
  mustReload: PropTypes.bool,
};

export default GenericError;
